import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Fornecedor } from '@/models/Fornecedor'
import Swal from 'sweetalert2'
import { fornecedorTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'
export const LOAD_ROLES = 'LOAD_ROLES'
export const LOAD_EVENTOS = 'LOAD_EVENTOS'

const getDefaultState = () => {
  return {
    picked: '',
    telefones: [
      { tipo: 'Comercial', format: 'com', title: 'Telefone', required: true },
    ],
    roles: [],
    loading: true,
    loadedEventos: [],
    isEditing: false,
    dialog: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [LOAD_EVENTOS] ({ commit }, { id }) {
    await api.listEntidade('evento').then(response => {
      let eventos
      if (id) {
        eventos = response.filter(evento => evento.classe === 'S')
      } else {
        eventos = response.filter(evento => evento.status === 1 && evento.classe === 'S')
      }
      eventos.sort((A, B) => {
        const a = A.descricao.toLowerCase()
          .toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')

        const b = B.descricao.toLowerCase()
          .toLowerCase()
          .replace(/[àáâãäå]/, 'a')
          .replace(/[èéêë]/, 'e')
          .replace(/[ìíîï]/, 'i')
          .replace(/[òóôõö]/, 'o')
          .replace(/[ùúûü]/, 'u')
          .replace(/[ç]/, 'c')
          .replace(/[^a-z0-9]/gi, '')
        return a < b ? -1 : a > b ? 1 : 0
      })
      commit(SET_STATE, { loadedEventos: eventos })
    })
  },
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit('SET_STATE', { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Fornecedor() }, { root: true })
    await dispatch(LOAD_ROLES)
    await dispatch(LOAD_EVENTOS, { id })
    if (id) {
      commit(SET_STATE, { isEditing: true, dialog: false })
      await api.getEntidade('fornecedor', id).then(response => {
        commit(SET_STATE, { picked: response.data[0].pessoaFis ? 'fisica' : 'juridica', loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new Fornecedor(fornecedorTransformer(response.data[0], state.telefones)) }, { root: true })
      })
    } else {
      commit(SET_STATE, { dialog: true, loading: false, isEditing: false })
    }
  },
  async [LOAD_ROLES] ({ dispatch, commit }) {
    await api.getEntidade('role', 3).then(
      response => {
        const roles = response.data
        commit(SET_STATE, { roles })
      },
    )
  },
  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Cadastrando Fornecedor!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data }
        const [day, month, year] = form.data_ingresso.split('/')
        form.data_ingresso = year + '-' + month + '-' + day
        form.role_id = form.role
        form.status = form?.status ? form.status : 0
        form.pessoaFis = state.picked === 'fisica'
        const evento = form.eventos.map(row => {
          return {
            evento_id: row.evento.id,
            valor_evento: row.valor_evento,
          }
        })
        form.eventos = evento;
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'fornecedor', form.id)
            : api.cadastrarEntidade(form, 'fornecedor')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Fornecedor atualizado com sucesso!'
                : 'Fornecedor cadastrado com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })
            dispatch('fornecedores/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/fornecedores`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              text: error.errors ? error.errors : error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
